export default __webpack_public_path__ + "static/media/setReadingGoalDark.36659384.png";